// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zlj8N{padding:0 16px;margin:0 0 32px}@media screen and (min-width:768px){.zlj8N{padding:0}}@media screen and (min-width:1552px){.zlj8N{padding-left:92px}}.JXkD8+.JXkD8{margin-top:32px}@media screen and (min-width:768px){.JXkD8+.JXkD8{margin-top:40px}}.ASq5f{margin:0 0 16px;font-family:\"Merriweather\",serif;font-size:24px;font-weight:700}.eNS9q,.ASq5f{line-height:30px}.eNS9q{margin:0;font-size:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "zlj8N",
	"item": "JXkD8",
	"title": "ASq5f",
	"content": "eNS9q"
};
module.exports = ___CSS_LOADER_EXPORT___;
